import { render, staticRenderFns } from "./AppTpProd.vue?vue&type=template&id=52fef3b2&scoped=true"
import script from "./AppTpProd.vue?vue&type=script&lang=js"
export * from "./AppTpProd.vue?vue&type=script&lang=js"
import style0 from "./AppTpProd.vue?vue&type=style&index=0&id=52fef3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fef3b2",
  null
  
)

export default component.exports